export default __webpack_public_path__ + "static/media/Orden_de_compra.1e10ec81.svg";